import i18n from "config/i18next";

i18n.addResources("es", "pickers", {
  pending: "Solicitudes pendientes",
  pickers: "pickers",
  exportWithoutSave: "Exportar sin guardar",
});
